import React, { useEffect, useRef, useState } from 'react';

import '../styles.css';
import moment from 'moment';
import { Field, Form, Formik, useFormik } from 'formik';
import * as Yup from 'yup';
import infoIco from 'assets/images/i-circle.svg';
import { Button } from 'react-bootstrap';
import LoginService from 'pages/login/services/login.service';
import { toast } from 'react-toastify';
import Toast from 'shared/common/toast';
import { userStore } from 'store/UserStore';
import hidden from '../../../assets/images/hidden.png';
import eye from '../../../assets/images/eye.png';
import successIco from '../../../assets/images/check.png';
import CustomerOnboardingHttp from '../../customer-onboarding/services/customer.service';

interface PropsType {
  customerId: any;
  handleModal: any;
  isShow: boolean;
}

const PanCardUpload: React.FC<PropsType> = ({
  customerId,
  handleModal,
  isShow,
}) => {
  const ref = useRef(null);
  const [isPanVerify, setPanVerify] = useState(true);
  const [isPanVerifing, setPanVerifing] = useState(false);
  const [isPanVerifySuccess, setPanVerifySuccess] = useState(false);
  const [isPanVerifyFeild, setPanVerifyFeild] = useState(false);

  const [isPanUploading, setPanUploading] = useState(false);
  const [isPanUploadSuccess, setPanUploadSuccess] = useState(false);
  const [isPanUploadFeild, setPanUploadFeild] = useState(false);
  const [panNumber, setPanNumber] = useState<any>('');
  const [panDetails, setPanDetails] = useState<any>('');
  const [selectedFile, setSelectedFile] = useState<any>(true);
  const [panOcr, setPanOcr] = useState<any>('');
  const [loading, setLoading] = useState<any>(false);
  const [show, setShow] = useState<any>(false);
  const [user] = userStore((state: any) => [state.user]);

  const toVerify = () => {
    setPanVerify(true);
    setPanVerifing(false);
    setPanVerifySuccess(false);
    setPanVerifyFeild(false);
  };

  const verifyInprograss = () => {
    setPanVerify(false);
    setPanVerifing(true);
    setPanVerifySuccess(false);
    setPanVerifyFeild(false);
  };

  const verifySuccess = () => {
    setPanVerify(false);
    setPanVerifing(false);
    setPanVerifySuccess(true);
    setPanVerifyFeild(false);
  };

  const verifyFeild = () => {
    setPanVerify(false);
    setPanVerifing(false);
    setPanVerifySuccess(false);
    setPanVerifyFeild(true);
  };

  const uploadInprograss = () => {
    setPanUploading(true);
    setPanUploadSuccess(false);
    setPanUploadFeild(false);
  };

  const uploadSuccess = () => {
    setPanUploading(false);
    setPanUploadSuccess(true);
    setPanUploadFeild(false);
  };

  const uploadFeild = () => {
    setPanUploading(false);
    setPanUploadSuccess(false);
    setPanUploadFeild(true);
  };

  const panVerify = async (values: any, setErrors: any) => {
    let errors = {} as any;
    if (!ref.current.values.pan_number) {
      errors.pan_number = 'Please enter an valid pan number.';
      setErrors(errors);
      return;
    }

    // if (!isPanUploadSuccess) {
    //   errors.pan_image = 'You have uploded an invalid pan image.';
    //   setErrors(errors);
    //   return;
    // }

    verifyInprograss();
    try {
      const res: any = await CustomerOnboardingHttp.verifyPanNumber({
        pan: ref.current.values.pan_number,
      });
      if (res && res.status === 200) {
        setPanNumber(res.data.data.kycId);
        setPanDetails(res.data.data);
        setShow(true);
        verifySuccess();
      } else {
        verifyFeild();
        toast.error(res.data.errors[0].title);
      }
      setLoading(false);
    } catch (err: any) {
      verifyFeild();
      toast.error(err.data.errors[0].title);
    }
  };

  const fileChanged = (event: any) => {
    setSelectedFile(event.target.files[0]);
    onFileUpload(event);
  };

  const onFileUpload = async (file) => {
    //setLoading(true);
    // Create an object of formData
    uploadInprograss();
    const formData = new FormData();

    // Update the formData object
    formData.append('myFile', file.target.files[0], file.target.files[0].name);

    // Details of the uploaded file
    try {
      const res: any = await CustomerOnboardingHttp.panOcr(formData);
      if (res.status === 200 && res.data.data) {
        setPanOcr(res.data.data.kycId);
        uploadSuccess();
        setLoading(false);
      } else {
        uploadFeild();
      }
    } catch (e: any) {
      uploadFeild();
    }
  };

  const updateEntCustomer = async (values: any, setErrors: any) => {
    setLoading(true);

    let errors = {} as any;
    if (!isPanVerifySuccess) {
      errors.pan_number = 'You have entered an invalid pan number.';
    }
    // if (!isPanUploadSuccess) {
    //   errors.pan_image = 'You have uploded an invalid pan image.';
    // }
    setErrors(errors);
    if (!isPanVerifySuccess) {
      // if (!isPanVerifySuccess || !isPanUploadSuccess) {
      setLoading(false);

      return;
    }

    try {
      const customer_data = {
        requiredStatus: 'ENABLED',
        kyc: {
          pan: {
            kycId: panNumber,
          },
          // pan_ocr: {
          //   kycId: panOcr,
          // },
        },
      };

      const cus_res: any = await CustomerOnboardingHttp.updateCustomer(
        customer_data,
        customerId,
        user?.userId
      );
      //
      if (cus_res.status === 200 && cus_res.data) {
        toast.success('Pan Card Uploaded!');
        handleModal(false);
        // handleCreate(cus_res.data.data);
      } else {
        toast.error(cus_res.data.errors[0].title);
      }
      setLoading(false);
    } catch (err: any) {
      toast.error(err.data.errors[0].title);
      setLoading(false);
    }
  };

  return (
    <>
      <div
        onClick={() => handleModal(false)}
        className={`Backdrop 
        ${isShow ? 'BackdropActive' : ''}`}
      />
      <div
        className={`Sidebar ${isShow ? 'Open' : ''}`}
        style={{ width: '420px' }}
      >
        <div className='modal-header'>
          <h4 className='modal-title'>Pan Card Update</h4>
          <span
            aria-hidden='true'
            className='Close'
            onClick={() => {
              handleModal(false);
              setShow(false);
            }}
          >
            &times;
          </span>
        </div>
        {!show ? (
          <div className='p-5'>
            <Formik
              innerRef={ref}
              initialValues={{ pan_number: '', pan_image: '' }}
              onSubmit={(values, { setSubmitting, setErrors, resetForm }) => {
                setSubmitting(false);
                panVerify(values, setErrors);
                // resetForm({
                //     values: {
                //         pan_number: '', pan_image: ''
                //     },
                // });
                // updateEntCustomer(values,setErrors);
              }}
              validationSchema={Yup.object().shape({
                pan_number: Yup.string().required('PAN is required'),
                // pan_image: Yup.mixed().required('PAN image is required'),
              })}
            >
              {({
                isSubmitting,
                errors,
                touched,
                values,
                setFieldValue,
                setErrors,
              }) => (
                <Form translate={undefined}>
                  <div className='form-group mb-2'>
                    <label className='form-label'>Enter your PAN</label>
                    <div className='input-group mb-3'>
                      <Field
                        type='text'
                        className='form-control'
                        name='pan_number'
                        aria-label='Text input with checkbox'
                        value={values.pan_number}
                        onChange={(e) => {
                          toVerify();
                          setFieldValue(
                            'pan_number',
                            e.target.value?.toUpperCase()
                          );
                        }}
                      />
                    </div>
                    <div className='error'>
                      {errors.pan_number && touched.pan_number && (
                        <small id='my-helper-text'>
                          <>
                            <img src={infoIco} alt='' />
                            {errors.pan_number}
                          </>
                        </small>
                      )}
                    </div>
                  </div>
                  {/* <div className='form-group mb-2'>
                    <label className='form-label'>PAN Image</label>
                    <div className='input-group mb-3'>
                      <Field
                        type='file'
                        placeholder=''
                        name='pan_image'
                        className='form-control'
                        value={values.pan_image}
                        onChange={(e) => {
                          fileChanged(e);
                          setFieldValue('pan_image', e.target.value);
                        }}
                      />
                      {isPanUploading ||
                      isPanUploadSuccess ||
                      isPanUploadFeild ? (
                        <div className='input-group-text px-2'>
                          {isPanUploading ? (
                            <div
                              className='spinner-grow text-success'
                              style={{ width: '1rem', height: '1rem' }}
                              role='status'
                            >
                              <span className='visually-hidden'>
                                Loading...
                              </span>
                            </div>
                          ) : (
                            ''
                          )}
                          {isPanUploadSuccess ? (
                            <img
                              style={{ width: '20px' }}
                              src={successIco}
                              alt=''
                            />
                          ) : (
                            ''
                          )}
                          {isPanUploadFeild ? <img src={infoIco} alt='' /> : ''}
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                    <div className='error'>
                      {errors.pan_image && touched.pan_image && (
                        <small id='my-helper-text'>
                          <>
                            <img src={infoIco} alt='' />
                            {errors.pan_image}
                          </>
                        </small>
                      )}
                    </div>
                  </div> */}
                  <div className='row'>
                    <div className='form-group my-4'>
                      <Button
                        disabled={loading || isPanUploading}
                        variant='primary'
                        className='w-100'
                        size='lg'
                        type='submit'
                      >
                        {!loading ? (
                          'Verify'
                        ) : (
                          <div
                            className='spinner-border text-white'
                            role='status'
                          >
                            <span className='visually-hidden'>Loading...</span>
                          </div>
                        )}
                      </Button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        ) : (
          <div className='p-5'>
            <Formik
              innerRef={ref}
              enableReinitialize
              initialValues={{
                number: panDetails.pan,
                pan_name: panDetails.name,
              }}
              onSubmit={(values, { setSubmitting, setErrors }) => {
                setSubmitting(false);
                updateEntCustomer(values, setErrors);
              }}
              validationSchema={Yup.object().shape({
                number: Yup.string().required('PAN is required'),
                pan_name: Yup.mixed().required('PAN Name is required'),
              })}
            >
              {({
                isSubmitting,
                errors,
                touched,
                values,
                setFieldValue,
                setErrors,
              }) => (
                <Form translate={undefined}>
                  <div className='form-group mb-2'>
                    <label className='form-label'>Enter your PAN</label>
                    <div className='input-group mb-3'>
                      <Field
                        disabled={true}
                        type='text'
                        className='form-control'
                        name='number'
                        aria-label='Text input with checkbox'
                        value={values.number}
                        onChange={(e) => {
                          toVerify();
                          setFieldValue('number', e.target.value);
                        }}
                      />
                    </div>
                    <div className='error'>
                      {errors.number && touched.number && (
                        <small id='my-helper-text'>
                          <>
                            <img src={infoIco} alt='' />
                            {errors.number}
                          </>
                        </small>
                      )}
                    </div>
                  </div>
                  <div className='form-group mb-2'>
                    <label className='form-label'>Name</label>
                    <div className='input-group mb-3'>
                      <Field
                        type='text'
                        className='form-control'
                        name='pan_name'
                        disabled
                        value={values.pan_name}
                        onChange={(e) => {
                          toVerify();
                          setFieldValue('pan_name', e.target.value);
                        }}
                      />
                    </div>
                    <div className='error'>
                      {errors.pan_name && touched.pan_name && (
                        <small id='my-helper-text'>
                          <>
                            <img src={infoIco} alt='' />
                            {errors.pan_name}
                          </>
                        </small>
                      )}
                    </div>
                  </div>
                  <div className='row'>
                    <div className='form-group my-4'>
                      <Button
                        onClick={() => {
                          setShow(false);
                        }}
                        variant='primary'
                        className='bg-white btn btn-lg btn-secondary float-end mx-1'
                        size='lg'
                        style={{ color: '#99834d' }}
                        type='button'
                      >
                        Cancel
                      </Button>
                      <Button
                        disabled={loading}
                        variant='primary'
                        className='float-end'
                        size='lg'
                        type='submit'
                      >
                        {!loading ? (
                          'Verify'
                        ) : (
                          <div
                            className='spinner-border text-white'
                            role='status'
                          >
                            <span className='visually-hidden'>Loading...</span>
                          </div>
                        )}
                      </Button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        )}
      </div>
    </>
  );
};

export default PanCardUpload;
